module.exports = __webpack_public_path__ + "static/media/mag1.d5f9513f.png";